import storage from '@/utils/localStorage'
import moment from 'moment'

const prefix = '_calendar.'

const state = {
  selected: storage.get(prefix + 'id') || null,
  date: moment().format() || null,
  selectedEvent: null
}

const mutations = {
  setEvent (state, event) {
    state.selectedEvent = event
  },
  setDate (state, date) {
    state.date = date
  },
  set (state, payload) {
    state.selected = payload

    storage.set(prefix + 'id', payload)
  },
  clean (state) {
    state.selected = state.info = null

    storage.remove(prefix + 'id')
  }
}

const actions = {
  set ({ commit }, calendar) {
    commit('set', calendar)
  },
  clean ({ commit }) {
    commit('clean')
  }
}

const getters = {

}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/calendar.js